// extracted by mini-css-extract-plugin
export default {"wrapper":"language-switcher_wrapper__S6d-Z","select":"language-switcher_select__P-nnE","icon":"language-switcher_icon__h91jS","flagIcon":"language-switcher_flagIcon__8S3mk"};